/**templates functions for styling */
import React from 'react'
import { renderToString } from 'react-dom/server'
import { FaPlusCircle, FaInfo } from "react-icons/fa";
import { Clock } from 'react-feather';
import { IoMdCheckboxOutline, IoMdSquareOutline, IoMdBook } from "react-icons/io";


export const taskTemplate = (task) => {
    return `
        <span class="${task.raw.type === "button" ? "addTask" : "checkTask"}" style="display: flex; padding: 2px;">
            <span class=" ${task.raw.type === 'button' ? 'iconAddTask' : 'iconTask'} addNewTicker" original=${task.raw.check}>
            ${task.raw.type === 'button' ? renderToString(<FaPlusCircle size={15} />)
                :
                renderToString(<IoMdCheckboxOutline size={20} color={'#212121'} className={task.raw.check ? 'visible' : 'hidden_icon'} />) +
                renderToString(<IoMdSquareOutline size={20} color={'black'} className={task.raw.check ? 'hidden_icon' : 'visible'} />)}
            </span>
            <span class=" ${task.raw.type === 'button' ? 'labelAddTask' : 'labelTask'}">
                ${task.raw.type === 'button' ? '' : task.title}
            </span>
        <span>
    `
}

export const weatherTemplate = (forecast) => {
    return `
        <div>
            <span class="imageWeather">
                <img height="32" width="32" title="${forecast.title}" style="" src="https://www.weatherbit.io/static/img/icons/${forecast.icon}.png">
            </span>
            <span class="forecast">
                <span style="position:relative;top:-10px;">
                    H ${Math.trunc(forecast.maxTemp)}°
                </span>
                <span style="position:relative;top:-10px;">
                    L ${Math.trunc(forecast.minTemp)}°
                </span>
            </div>
        </div>
    `
}

export const checkTemplate = (task,ticker) => {
    return `
        <div id="${task.id}" category="${task.category}" tickerType="${ticker}" class="checklist checklist--task">
                <span class="${task.raw.type === 'button' ? 'hidden-border' : ''}"> </span>
                <span class="${task.raw.type === "button" ? "addTask" : "checkTask"}" style="display: block; padding: 2px;">
                    <span class="${task.raw.type === 'button' ? 'iconAddTask' : 'iconTask iconTask--check'}" original=${task.raw.check}>
                        ${task.raw.type === 'button' ? renderToString(<FaPlusCircle size={15} />)
                        :
                        renderToString(<IoMdCheckboxOutline size={20} color={'#212121'} className={task.raw.check ? 'visible' : 'hidden_icon'} />) +
                        renderToString(<IoMdSquareOutline size={20} color={'black'} className={task.raw.check ? 'hidden_icon' : 'visible'} />)}
                        </span>

                    <span class="${task.raw.type === 'button' ? 'labelAddTask' : 'checkLabelTask'} taskTitle" title="${task.title}">
                        ${task.raw.type === 'button' ? ' Add Task' : task.title}

                        ${renderToString(<FaInfo size={10} className="checklist__info" color={'black'} />)}
                    </span>
                </span>
        </div>
        `;
}

export const reminderTemplate = (reminder) => {
    return `
        <div id="${reminder.id}" category="${reminder.category}" tickerType="reminders" class="checklist">
                <span class="reminder" style="display: block; padding: 2px;">
                    <span class="iconReminder">
                        ${renderToString(<Clock size={20} color={'black'} />)}
                    </span>
                    <span class="labelTask taskTitle" title="${reminder.title}">
                        ${reminder.title}
                    </span>
                <span>
        </div>`;
}

export const noteTemplate = (note) => {
    return `
        <div id="${note.id}" category="${note.category}" tickerType="notes" class="checklist">
            <span class="notes" style="display: flex; padding: 2px;">
                <span class="iconTask">
                    ${renderToString(<IoMdBook size={20} color={'black'} />)}
                </span>
                <span class="noteLabelTask" title="${note.title}">
                    ${note.title}
                </span>
            <span>
        </div>
    `;
}
